<template>
  <rect
    x="34.0801"
    y="12.5"
    width="63.486"
    height="84.4902"
    rx="0.5"
    fill="#A3B1D1"
    stroke="#8497C2"
    stroke-linejoin="round"
  />
  <rect
    x="30.2991"
    y="16.6177"
    width="64.486"
    height="85.4902"
    rx="1"
    fill="#DDE3F0"
  />
  <rect
    x="26"
    y="20.8921"
    width="64.486"
    height="85.4902"
    rx="1"
    fill="white"
  />
  <path
    d="M58.916 26.3791V16.1408C58.916 13.529 61.7944 13.529 61.7944 16.1408C61.7944 18.9877 61.7944 26.0914 61.7944 28.883C61.7944 32.3726 55 32.5798 55 28.883C55 25.4868 55 15.6227 55 11.9534C55 5.15404 64.6729 5.54664 64.6729 11.9534"
    stroke="#8497C2"
    stroke-linecap="round"
  />
  <rect x="42.5795" y="36" width="31" height="3" rx="1" fill="#8497C2" />
  <rect
    x="33.5234"
    y="46.5391"
    width="49.4393"
    height="2.13725"
    rx="1"
    fill="#D0D7E7"
  />
  <rect
    x="33.5234"
    y="54.0195"
    width="49.4393"
    height="2.13725"
    rx="1"
    fill="#D0D7E7"
  />
  <rect
    x="33.5234"
    y="61.5"
    width="49.4393"
    height="2.13725"
    rx="1"
    fill="#D0D7E7"
  />
  <rect
    x="33.5234"
    y="68.9805"
    width="49.4393"
    height="2.13725"
    rx="1"
    fill="#D0D7E7"
  />
  <rect
    x="33.5234"
    y="76.4609"
    width="49.4393"
    height="2.13725"
    rx="1"
    fill="#D0D7E7"
  />
  <rect
    x="67.9159"
    y="90.353"
    width="15.0467"
    height="2.13725"
    rx="1"
    fill="#A3B1D1"
  />
  <rect
    x="33.5234"
    y="90.353"
    width="15.0467"
    height="2.13725"
    rx="1"
    fill="#A3B1D1"
  />
  <path
    d="M13.2008 107.055L11.374 103.89C10.9079 103.083 12.1728 102.353 12.6388 103.16C13.1468 104.04 14.7272 106.777 15.2253 107.64C16.014 109.006 13.6928 110.346 12.9041 108.98C12.2981 107.931 10.2252 104.34 9.57047 103.206C8.35727 101.105 12.089 99.2299 13.2322 101.21C14.5137 103.43 17.0684 107.854 17.2112 108.102C18.6386 110.574 13.7324 113.114 12.3942 110.796C11.9481 110.023 9.67247 106.082 8.32593 103.75"
    stroke="#F9FBFC"
    stroke-width="0.7"
    stroke-linecap="round"
  />
  <path
    d="M107.429 74.2943L109.557 70.6732C110.099 69.7494 111.547 70.5999 111.004 71.5236C110.413 72.5305 108.572 75.6632 107.992 76.6505C107.073 78.2139 104.417 76.6532 105.335 75.0898C106.041 73.8886 108.455 69.7796 109.218 68.4818C110.631 66.077 114.622 68.7448 113.291 71.0107C111.798 73.551 108.823 78.615 108.657 78.898C106.994 81.7274 101.672 78.2623 103.231 75.6097C103.75 74.7255 106.401 70.2148 107.969 67.5456"
    stroke="#DAE5F5"
    stroke-width="0.9"
    stroke-linecap="round"
  />
  <path
    d="M13.9883 30.0061L12.7192 27.0224C12.3954 26.2613 13.5881 25.7539 13.9119 26.5151C14.2648 27.3448 15.3627 29.926 15.7088 30.7395C16.2567 32.0277 14.0679 32.9587 13.52 31.6705C13.099 30.6808 11.6589 27.2951 11.204 26.2258C10.3612 24.2443 13.8501 22.9937 14.6443 24.8608C15.5346 26.9538 17.3094 31.1265 17.4086 31.3596C18.4002 33.691 13.8052 35.4009 12.8756 33.2152C12.5657 32.4866 10.9848 28.7699 10.0493 26.5706"
    stroke="#E5EAF4"
    stroke-width="0.5"
    stroke-linecap="round"
  />
</template>
